
import Dashboard from "views/Dashboard/Dashboard.jsx";
import Asm from "views/AsmReport/Asm.jsx";
import Msdsales from 'views/MDCReport/Msdsales';
import StoreReport from 'views/storeReport/StoreReport';
import Tables from "views/Dashboard/Abstract.js";
import DetailView from "views/Dashboard/Detailview.js";
import VisiCoolerImageReport from 'views/VisiCoolerImageReport/visiCoolerImageReport';
import RedFreshness from 'views/RedFreshness/RedFreshness';
import ModalResults from 'views/ModalResults/ModalResults';
import RoleBasedAccess from 'views/RoleBasedAccess/RoleBasedAccess';
import DownloadExcel from 'views/downloadExcel/DownloadExcel';
import VarianceReport from 'views/VarianceReport/VarianceReport.jsx';
import StoreAbstract from 'views/StoreAbstract/StoreAbstract';
import ManualShelfCount from 'views/ManualShelfCounts/ManualShelfCounts.js';
import DisReport from "views/disReport/DisReport";
import VarainceReportAiVsManual from "views/VarianceReport/VarianceReportAiVsManual/VarianceReportAiVsManual.jsx";import UserRegistration from "views/Admin/UserRegistration";
import MasterSheets from "views/Admin/MasterSheets";
import ImageValidationQuality from "views/ImageValidationQuality/ImageValidationQuality";
;


export const componentMap = {
  "/dashboard": Dashboard,
  "/Asm": Asm,
  "/MDC": Msdsales,
  "/Softdrink": StoreReport,
  "/ReportCenter": DownloadExcel,
  "/visicoolerImage": VisiCoolerImageReport,
  "/redFreshness": RedFreshness,
  "/modelResults": ModalResults,
  "/role-based-access": RoleBasedAccess,
  "/user-registartion":UserRegistration,
  "/mastersheet":MasterSheets,
  "/variance-report": VarianceReport,
  "/variance-report-aivsmanl":VarainceReportAiVsManual,
  "/storeAbstract": StoreAbstract,
  "/manual-shelf-counts": ManualShelfCount,
  "/disReport":DisReport,
  "/imagequalityvalidation" :ImageValidationQuality,

  // From collapsed groups
  "/abstract": Tables,
  "/detail": DetailView,
  "/VisibilityItems": Tables, 

  // Fallback
  default: Dashboard,
};

export default componentMap;